import { render, staticRenderFns } from "./ItemUpdateDialogBasicData.vue?vue&type=template&id=4f6da95f&scoped=true"
import script from "./ItemUpdateDialogBasicData.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6da95f",
  null
  
)

export default component.exports